<template>
    <div class="popup-component" id="popup-component">
        <div class="popup-component__content">
            <div class="popup-component__content-text" v-if="!is_slot">
                
                {{text}}

                <span v-if="moreText">
                    <br> {{ moreText }}
                </span>
            </div>


          <header>
            <slot name="header"></slot>
          </header>

            <div class="popup-component__content-buttons">
                
                <div class="popup-component__button-cancel"
                    v-if="!growButton"
                    @click="clickCancelPopup()"
                >
                    <span>Отмена</span>
                </div>
                <div class="popup-component__button-delete"
                    v-if="!growButton"
                    @click="clickDeletePopup()"
                >
                    <span>{{ secondButtonText }}</span>
                </div>
                <div class="popup-component__button-grow"
                    @click="clickGrowButtonPopup()"
                    v-if="growButton"
                >
                    <span>ок</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                default: ''
            },
            growButton: {
                default: false
            },
            moreText: {
                default: false
            },
            secondButtonText: {
              default: 'Удалить'
            },
            is_slot: {
              default: false
            }
        },
        methods: {
            async clickCancelPopup() {
                this.$emit('clickCancelPopup')
            },
            async clickDeletePopup() {
                this.$emit('clickDeletePopup')
            },
            async clickGrowButtonPopup() {
                this.$emit('clickGrowButtonPopup')
            }
        }
    }
</script>

<style lang="less">
    .popup-component {
        width: 100vw;
        height: 100vh;
        position: absolute;
        min-height: 430px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }

    .popup-component__content {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        padding: 14px 20px;
        border-radius: 13px;
        max-width: 343px;
        width: 100%;
    }

    @import '~/assets/fonts/roboto/Roboto-Medium.less';

    .popup-component__content-text {
        text-align: center;
        font-size: 15px;
        color: #31283D;
        font-family: 'Roboto-Medium';
    }

    .popup-component__content-buttons {
        display: flex;
        margin-top: 16px;
        align-items: center;
        justify-content: center;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .popup-component__button-cancel {
        height: 22px;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px dashed black;
        margin-right: 45px;
        cursor: pointer;
        font-size: 16px;
        line-height: 12px;
        color: #31283D;
        font-family: 'Montserrat-Medium';
    }

    .popup-component__button-delete {
        width: 151px;
        height: 44px;
        background-color:#674FFD;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        text-align: center;
        line-height: 12px;
        cursor: pointer;
        font-size: 16px;
        font-family: 'Montserrat-Medium';
    }

    .popup-component__button-grow {
        height: 44px;
        width: 95%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #674FFD;
        border-radius: 5px;
        text-transform: uppercase;
        color: #FFFFFF;
        text-align: center;
        font-size: 16px;
        line-height: 12px;
        font-family: 'Montserrat-Medium';
    }
</style>